import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './shared/guards/auth.guard';
import {PreAuthGuard} from './shared/guards/pre-auth.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',

  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
    canLoad: [PreAuthGuard]
  },
  {
    path: 'login/:code',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
    canLoad: [PreAuthGuard]
  },
  {
    path: 'redefinir-senha/:hash',
    loadChildren: () => import('./redefine-senha/redefine-senha.module').then(m => m.RedefineSenhaPageModule),
    canLoad: [PreAuthGuard]
  },
  {
    path: 'geral',
    loadChildren: () => import('./geral/geral.module').then(m => m.GeralPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'detalhe/:uf',
    loadChildren: () => import('./geral/detalhe/detalhe.module').then(m => m.DetalhePageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'detalhe',
    loadChildren: () => import('./geral/detalhe/detalhe.module').then(m => m.DetalhePageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'lista-atualizacoes',
    loadChildren: () => import('./geral/lista-atualizacoes/lista-atualizacoes.module').then(m => m.ListaAtualizacoesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'estacoes',
    loadChildren: () => import('./estacoes/estacoes.module').then(m => m.EstacoesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'estacoes-desatualizadas',
    loadChildren: () => import('./geral/estacoes-atualizadas/estacoes-atualizadas.module').then(m => m.EstacoesAtualizadasPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'estacoes-desatualizadas/:uf',
    loadChildren: () => import('./geral/estacoes-atualizadas/estacoes-atualizadas.module').then(m => m.EstacoesAtualizadasPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'painel',
    loadChildren: () => import('./painel/painel.module').then(m => m.PainelPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'gestao-dados',
    loadChildren: () => import('./gestao/gestao.module').then(m => m.GestaoPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'editar-dados/:id',
    loadChildren: () => import('./gestao/editar-dados/editar-dados.module').then(m => m.EditarDadosPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'importar',
    loadChildren: () => import('./importar/importar.module').then(m => m.ImportarPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'controle-acesso',
    loadChildren: () => import('./controle-acesso/controle-acesso.module').then(m => m.ControleAcessoPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'detalhe-usuario',
    loadChildren: () => import('./controle-acesso/detalhe-usuario/detalhe-usuario.module').then(m => m.DetalheUsuarioPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'detalhe-usuario/:id',
    loadChildren: () => import('./controle-acesso/detalhe-usuario/detalhe-usuario.module').then(m => m.DetalheUsuarioPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'detalhe-estacao',
    loadChildren: () => import('./estacoes/detalhe-estacao/detalhe-estacao.module').then(m => m.DetalheEstacaoPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'detalhe-atualizacao',
    loadChildren: () => import('./geral/estacoes-atualizadas/detalhe-atualizacao/detalhe-atualizacao.module').then(m => m.DetalheAtualizacaoPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'detalhe-atualizacao/:id',
    loadChildren: () => import('./geral/estacoes-atualizadas/detalhe-atualizacao/detalhe-atualizacao.module').then(m => m.DetalheAtualizacaoPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'detalhe-estacao/:id',
    loadChildren: () => import('./estacoes/detalhe-estacao/detalhe-estacao.module').then(m => m.DetalheEstacaoPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'notificacoes',
    loadChildren: () => import('./notificacoes/notificacoes.module').then(m => m.NotificacoesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'perfil',
    loadChildren: () => import('./perfil/perfil.module').then(m => m.PerfilPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'documentos',
    loadChildren: () => import('./documentos/documentos.module').then(m => m.DocumentosPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'editar-documentos/:id',
    loadChildren: () => import('./documentos/editar-documentos/editar-documentos.module').then(m => m.EditarDocumentosPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'cadastrar',
    loadChildren: () => import('./documentos/cadastrar/cadastrar.module').then(m => m.CadastrarPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'webservice/:id',
    loadChildren: () => import('./painel/webservice/webservice.module').then( m => m.WebservicePageModule),
    canLoad: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'geral',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
